/** Аватар клиента/группы в шапках и списках выбора (.cav): фото клиента, если есть, иначе инициалы */
export function Cav({ ini, photo, grp }: { ini?: string; photo?: string | null; grp?: boolean }) {
  return <span className={'cav' + (grp ? ' grp' : '') + (photo ? ' ph' : '')}>{photo ? <img src={photo} alt="" /> : ini}</span>;
}
